import { Section, SectionHeader } from "@/components/ui/Section";
import { StaggerChildren, StaggerItem } from "@/components/ui/AnimatedSection";
import { Users, Building2, Globe2, Compass } from "lucide-react";

const metrics = [
  {
    icon: Users,
    stat: "50+",
    label: "Founder & leadership teams advised globally",
    detail: "Repeat engagements with founders scaling from pre-seed through Series B and beyond.",
  },
  {
    icon: Building2,
    stat: "Startups & Enterprise",
    label: "Product, AI & platform advisory experience",
    detail: "From founder-led startups to established enterprises modernising operations and AI systems.",
  },
  {
    icon: Globe2,
    stat: "India + Global",
    label: "Experience across founder-led businesses worldwide",
    detail: "Engagements across India, Southeast Asia, the Gulf, Europe, the UK, North America and Australia.",
  },
  {
    icon: Compass,
    stat: "Founder-first",
    label: "Senior strategic guidance with execution depth",
    detail: "Advisory that translates directly into architecture, workflows, AI systems and operating cadence.",
  },
];

export function FounderImpactSection() {
  return (
    <Section background="muted" spacing="default">
      <SectionHeader
        eyebrow="Founder Impact"
        title="What partnering with Founder Mitra looks like."
        subtitle="Not a portfolio of logos. A pattern of clearer decisions, sharper execution and more confident founders."
        variant="dark"
        align="center"
      />
      <StaggerChildren className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" staggerDelay={0.07}>
        {metrics.map((m) => (
          <StaggerItem key={m.label}>
            <div className="group relative h-full rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-md p-7 transition-all duration-500 hover:border-accent/30 hover:bg-white/[0.07] hover:-translate-y-1.5">
              <div className="w-11 h-11 rounded-xl bg-white/10 border border-white/15 grid place-items-center mb-6 group-hover:bg-accent/15 group-hover:border-accent/40 transition-colors">
                <m.icon className="h-5 w-5 text-accent" strokeWidth={1.6} />
              </div>
              <p className="font-display font-bold text-white text-3xl md:text-[2rem] tracking-[-0.02em] leading-[1.05] mb-3">
                {m.stat}
              </p>
              <p className="text-white/85 text-sm font-medium mb-3 leading-snug">{m.label}</p>
              <p className="text-white/55 text-[13px] leading-[1.7]">{m.detail}</p>
            </div>
          </StaggerItem>
        ))}
      </StaggerChildren>
    </Section>
  );
}
